import { useEffect } from 'react';

const ALLOWED_TRACKING_PATHS = [
  '/home/customermanagement',
  '/home/customermanagement/follower',
  '/home/customermanagement/notification',
  '/customermanagement/block',
  '/home/analysis/point-report',
  '/home/analysis/calendar',
  '/home/analysis/daily/202503',
  '/home/analysis/weekly/202504',
  '/home/analysis/monthly/202505',
  '/home/analysis/periodically'
];

const customEventMap = {
  '/home/customermanagement': 'view_cmanage',
  '/home/customermanagement/follower': 'view_cmanage_follower',
  '/home/customermanagement/notification': 'view_cmanage_notification',
  '/customermanagement/block': 'view_cmanage_block',
  '/home/analysis/point-report' : 'view_report',
  '/home/analysis/calendar': 'view_report_calender',
  '/home/analysis/daily/202503' : 'view_report_daily',
  '/home/analysis/weekly/202504' : 'view_report_weekly',
  '/home/analysis/monthly/202505' : 'view_report_monthly',
  'home/analysis/periodically' : 'view_report_periodically'
  
};

class usePageTracking {
  static track(currentPath) {
    if (ALLOWED_TRACKING_PATHS.includes(currentPath)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        page_path: currentPath,
      });

      const eventName = customEventMap[currentPath];
      if (eventName) {
        window.dataLayer.push({ event: eventName });
      }
    }
  }
}


export default usePageTracking;